import * as React from 'react';

import { useBoolean, useLockFn } from 'ahooks';
import { Button, Divider, Form, Modal, notification, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import { CheckOutlinedIcon, DeleteOutlinedIcon } from 'components';
import { useSpecialOfferValue } from 'context';
import { deleteSpecialOffer } from 'services';
import { PATHNAME } from 'utils';

const {
  LOCAL: {
    SPECIAL_OFFERS: { BASE_URL: SPECIAL_OFFERS_BASE_URL },
  },
} = PATHNAME;

const SpecialOfferFormAction = () => {
  const [deleteModalInstance, deleteModalContextHolder] = Modal.useModal();
  const [deleteLoading, { toggle: toggleDeleteLoading }] = useBoolean();
  const { id, mode } = useSpecialOfferValue();
  const navigate = useNavigate();

  const handleDeleteSpecialOffer = useLockFn(
    async ({
      id,
    }: Pick<Required<ReturnType<typeof useSpecialOfferValue>>, 'id'>) => {
      toggleDeleteLoading();

      deleteSpecialOffer({ id })
        .then(() => {
          navigate(SPECIAL_OFFERS_BASE_URL);
          notification.success({
            message: 'تخفیف ویژه با موفقیت حذف شد.',
          });
        })
        .catch(message => {
          notification.error({
            message,
          });
        })
        .finally(() => {
          toggleDeleteLoading();
        });
    },
  );

  return (
    <div>
      <div className='px-6 pt-4'>
        <Typography.Title level={3} className='mb-0 text-base font-medium'>
          انتشار تخفیف ویژه
        </Typography.Title>
      </div>

      <Divider className='mb-8 mt-4' />

      <div className='px-6'>
        <Typography.Paragraph>
          از طریق این بخش می‌توانید تخفیف ویژه ساخته شده و یا ویرایش شده را
          منتشر کنید.
        </Typography.Paragraph>
      </div>

      <div className='flex flex-wrap-reverse items-center gap-2 p-6 *:m-0 *:shrink *:grow *:basis-40'>
        {mode === 'Update' ? (
          <Form.Item>
            <Button
              block
              danger
              className='flex items-center'
              loading={deleteLoading}
              icon={<DeleteOutlinedIcon />}
              onClick={async () => {
                const confirmed = await deleteModalInstance.confirm({
                  title: 'آیا از حذف این تخفیف ویژه اطمینان دارید؟',
                  width: 500,
                });
                if (id && confirmed) {
                  handleDeleteSpecialOffer({ id });
                }
              }}
            >
              <span>حذف تخفیف ویژه</span>
            </Button>
            {deleteModalContextHolder}
          </Form.Item>
        ) : null}

        <Form.Item>
          <Button
            block
            type='primary'
            htmlType='submit'
            icon={<CheckOutlinedIcon />}
          >
            {mode === 'Create' ? (
              <span>افزودن تخفیف ویژه جدید</span>
            ) : (
              <span>ذخیره تغییرات</span>
            )}
          </Button>
        </Form.Item>
      </div>
    </div>
  );
};

export { SpecialOfferFormAction };
